import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { WAF_CHECK_PATH_NAME } from './waf-check.constants';
import { WafCheckQuerySchema, WafCheckResultSchema } from './waf-check.schema';

export const WafCheckContract = terraContract
  .prefix(`/${WAF_CHECK_PATH_NAME}`)
  .router({
    check: terraContract
      .meta({
        openApi: true,
        permissions: [PERMISSIONS.VIEW_TESTS.name],
      })
      .route({
        method: 'GET',
        path: '/',
        summary: 'Check URL for WAF',
        description:
          'Checks whether a given URL is protected by a Web Application Firewall (WAF). Returns whether WAF was detected and whether the URL was reachable.',
        inputStructure: 'detailed',
      })
      .input(z.object({ query: WafCheckQuerySchema }))
      .output(WafCheckResultSchema),
  });
